export enum Language {
    DUTCH = 'nl',
    FRENCH = 'fr',
    GERMAN = 'de',
    ENGLISH = 'en',
    FLEMISH = 'vls',
}
